import React from "react";
import {
  getTodayInBrazil,
  formatDateForDisplay,
} from "../../../utils/dateUtils";
import { AdminPageHeader } from "../shared";
import { Icons } from "../../shared/Icons";
import { Last12MonthsRevenueChart } from "./Last12MonthsRevenueChart";
import { WeeklyRevenueChart } from "./WeeklyRevenueChart";
import { Next12MonthsRevenueChart } from "./Next12MonthsRevenueChart";
import { DailyAppointmentsChart } from "./DailyAppointmentsChart";
import { ReportsProfessionalSelect } from "./ReportsProfessionalSelect";
import { useAdminReportsProfessional } from "./useAdminReportsProfessional";

export const AdminProjecoesPage: React.FC = () => {
  const today = getTodayInBrazil();
  const {
    professionalIdForApi,
    showProfessionalSelector,
    professionals,
    selectedProfessionalId,
    setSelectedProfessionalId,
    loadingProfessionals,
  } = useAdminReportsProfessional();
  const chartProfessionalId = professionalIdForApi ?? undefined;

  return (
    <div className="space-y-4 sm:space-y-6 md:space-y-8 animate-fade-in">
      <AdminPageHeader
        icon={<Icons.Chart sx={{ fontSize: 28 }} />}
        title="Projeções"
        subtitle={`Referência: ${formatDateForDisplay(today)} • Gráficos e tendências`}
        rightContent={
          showProfessionalSelector ? (
            <ReportsProfessionalSelect
              professionals={professionals}
              selectedProfessionalId={selectedProfessionalId}
              onSelectProfessional={setSelectedProfessionalId}
              loading={loadingProfessionals}
            />
          ) : undefined
        }
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
        <Last12MonthsRevenueChart professionalId={chartProfessionalId} />
        <WeeklyRevenueChart professionalId={chartProfessionalId} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
        <Next12MonthsRevenueChart professionalId={chartProfessionalId} />
        <DailyAppointmentsChart professionalId={chartProfessionalId} />
      </div>
    </div>
  );
};
